const FALLBACK = 'https://api.lexikonn.eu/salegames';
const BASE = process.env.REACT_APP_API_BASE && process.env.REACT_APP_API_BASE.trim();
const API = BASE.replace(/\/+$/,'');

const api = {
    async get(path, init = {}) {
        const url = API + (path.startsWith('/') ? path : `/${path}`);
        const res = await fetch(url, { headers: { Accept: 'application/json' }, ...init });
        const ct = res.headers.get('content-type') || '';
        const text = await res.text();
        if (!res.ok) throw new Error(`HTTP ${res.status} ${res.statusText}\n${text.slice(0,500)}`);
        if (!/application\/json/i.test(ct)) throw new Error(`Non-JSON response\ncontent-type: ${ct}\nbody: ${text.slice(0,500)}`);
        return JSON.parse(text);
    }
};

export default api;
